(function () {
  'use strict';

  // Re-observe any dynamically added animated elements
  var animObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        animObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  function observe() {
    document.querySelectorAll(
      '.fade-up:not(.is-visible), .fade-in:not(.is-visible), ' +
      '.slide-in-left:not(.is-visible), .slide-in-right:not(.is-visible), ' +
      '.stagger-children:not(.is-visible), ' +
      '.brand-statement__line:not(.is-visible), ' +
      '.brand-statement__copy:not(.is-visible)'
    ).forEach(function (el) { animObserver.observe(el); });
  }

  observe();

  // Parallax on hero overlay
  var heroOverlay = document.querySelector('.hero-video__overlay');
  if (heroOverlay) {
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y < window.innerHeight) {
        heroOverlay.style.transform = 'translateY(' + (y * 0.15) + 'px)';
      }
    }, { passive: true });
  }

  // Smooth number counters (used on stat sections if added later)
  function animateCounter(el) {
    var target = parseInt(el.dataset.target || el.textContent, 10);
    if (isNaN(target)) return;
    var duration = 1800;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(eased * target).toLocaleString();
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var counterObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        counterObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('[data-counter]').forEach(function (el) {
    counterObserver.observe(el);
  });

  // Expose re-observe for dynamic content
  window.CATCHY = window.CATCHY || {};
  window.CATCHY.reobserve = observe;
})();

/* ══════════════════════════════════════
   HOME PAGE — Section Entrance Animations
   Runs ONCE per session (sessionStorage flag)
   Each section animates from a different direction
══════════════════════════════════════ */
(function () {
  if (document.body.dataset.template !== 'index' &&
      !document.querySelector('.template-index')) return;

  /* direction map per section type */
  var DIRS = {
    'hero-video':           null,          /* skip — already has own animation */
    'brand-statement':      'up',
    'countdown-timer':      'up',
    'marquee-shipping':     null,          /* skip — it's a ticker */
    'trust-icons':          'up',
    'category-tabs':        'up',
    'featured-brands':      'up',
    'collection-one':       'right',
    'premium-image-banner': 'left',
    'collection-two':       'right',
    'video-carousel':       'up',
    'before-after-reviews': 'left',
    'reviews-carousel':     'right',
    'instagram-feed':       'up'
  };

  var DIST = '48px';
  var DUR  = '0.75s';
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

  /* add initial hidden state — works on both shopify-section wrapper and direct section tags */
  function applyReveal(el, dir) {
    if (!dir || dir === 'null') return;
    var tx = '0', ty = '0';
    if (dir === 'up')    ty = DIST;
    if (dir === 'down')  ty = '-' + DIST;
    if (dir === 'right') tx = '-' + DIST;
    if (dir === 'left')  tx = DIST;
    el.style.opacity    = '0';
    el.style.transform  = 'translate(' + tx + ', ' + ty + ')';
    el.style.transition = 'none';
    el.dataset.revealDir = dir;
  }

  /* via shopify-section wrapper */
  document.querySelectorAll('.shopify-section').forEach(function (wrap) {
    var id  = wrap.id.replace('shopify-section-', '');
    var dir = DIRS[id];
    if (dir === null || dir === undefined) return;
    var inner = wrap.firstElementChild;
    if (inner) applyReveal(inner, dir);
  });

  /* via direct data-reveal-dir on section tags */
  document.querySelectorAll('[data-reveal-dir]').forEach(function (el) {
    if (el.style.opacity === '0') return; /* already handled above */
    applyReveal(el, el.dataset.revealDir);
  });

  /* IntersectionObserver — animate when in view */
  var revealed = 0;
  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = revealed * 0.05;
      revealed++;
      /* small stagger for elements visible on load */
      setTimeout(function () {
        el.style.transition = 'opacity ' + DUR + ' ' + EASE + ', transform ' + DUR + ' ' + EASE;
        el.style.opacity    = '1';
        el.style.transform  = 'translate(0, 0)';
        revealObs.unobserve(el);
      }, delay * 1000);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

  /* observe ALL elements that got hidden */
  document.querySelectorAll('[data-reveal-dir]').forEach(function (el) {
    if (el.style.opacity === '0') revealObs.observe(el);
  });
})();
